module.exports = __WEBPACK_EXTERNAL_MODULE_174__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
// module id = 174
// module chunks = 0